import styled from 'styled-components';
import { space, color, textAlign, fontSize, fontWeight } from 'styled-system';
import { ThemeInterface } from '../theme/ThemeInterface';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { theme } from '../theme';

const H3 = styled.h3<StyledSystemProps>`
  ${space};
  ${color};
  ${fontSize};
  ${textAlign};
  ${fontWeight};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
`;

export default H3;

H3.defaultProps = {
  m: 0,
  fontSize: 2,
  color: theme.colors.charcoalGrey,
};



// WEBPACK FOOTER //
// ./src/typography/H3.ts